import {
  SURVEY_SECTION_END,
  SURVEY_SECTION_LANDING,
  SURVEY_SECTION_QUESTIONS,
  SURVEY_SECTION_SETTINGS,
} from 'sharedParts';

const surveySectionsList = {
  landing: {
    name: SURVEY_SECTION_LANDING,
    label: 'Landing',
  },
  questions: {
    name: SURVEY_SECTION_QUESTIONS,
    label: 'Survey',
  },
  end: {
    name: SURVEY_SECTION_END,
    label: 'Thank You',
  },
  settings: {
    name: SURVEY_SECTION_SETTINGS,
    label: 'Settings',
  },
};

export const isLandingSection = section =>
  section === surveySectionsList.landing.name;

export const isQuestionsSection = section =>
  section === surveySectionsList.questions.name;

export const isThanksSection = section =>
  section === surveySectionsList.end.name;

export default surveySectionsList;
